<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: 'welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>活动管理</el-breadcrumb-item>
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card>
      <!-- 搜索和添加 -->
      <div class="search-wrapper">
        <div class="search-toggle" @click="toggleSearch" v-show="isMobile">
          <i :class="isSearchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          <span>{{ isSearchExpanded ? '收起筛选' : '展开筛选' }}</span>
        </div>
        <div class="search-content" :class="{ 'search-content-mobile': isMobile }" v-show="!isMobile || isSearchExpanded">
          <el-row :gutter="10" class="search-row">
            <el-col :span="6">
              <el-input placeholder="请输入活动名称" v-model="searchQuery.title_cn" clearable @clear="handleSearch()" @keyup.enter.native="handleSearch()" size="medium" >
                <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
              </el-input>
            </el-col>
            <el-col :span="3">
              <el-select v-model="searchQuery.type" placeholder="活动类型" @change="handleSearch()" size="medium">
                <el-option v-for="(name, id) in activityTypes" :key="id" :label="name" :value="Number(id)" >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-select v-model="searchQuery.status" placeholder="活动状态" @change="handleSearch()" size="medium">
                <el-option v-for="(item, id) in statusMap" :key="id" :label="item.text" :value="Number(id)" >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-select v-model="searchQuery.signup_status" placeholder="报名状态" @change="handleSearch()" size="medium">
                <el-option :value="1" label="可报名"></el-option>
                <el-option :value="0" label="不可报名"></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-select v-model="searchQuery.hide_from_homepage" placeholder="主页展示" @change="handleSearch()" size="medium">
                <el-option :value="null" label="全部"></el-option>
                <el-option :value="false" label="展示"></el-option>
                <el-option :value="true" label="隐藏"></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-select v-model="searchQuery.is_deleted" placeholder="是否删除" @change="handleSearch()" size="medium">
                <el-option :value="0" label="有效活动"></el-option>
                <el-option :value="1" label="失效活动"></el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-button type="default" @click="resetSearch()" size="medium">重置</el-button>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 活动列表 -->
      <div class="table-scroll-wrapper">
        <el-table :data="activityList" style="width: 100%" border stripe>
        <el-table-column label="#" type="index" width="50" align="center"></el-table-column>
        <el-table-column label="活动名称" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.is_deleted === 1 ? 'deleted' : ''">{{ scope.row.title_cn }}</span>
          </template>
        </el-table-column>
        <el-table-column label="活动类型" width="100" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.is_deleted === 1 ? 'deleted' : ''">{{ getActivityType(scope.row.type) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="早鸟票状态" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.enable_early_bird ? '启用' : '禁用' }}</template>
        </el-table-column>
        <el-table-column label="交通费通道" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.can_pay_transportation ? '开启' : '关闭' }}</template>
        </el-table-column>
        <el-table-column label="活动状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="报名状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.signup_status === 1 ? 'success' : 'info'">
              {{ scope.row.signup_status === 1 ? '可报名' : '不可报名' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="主页展示" width="100" align="center">
          <template slot-scope="scope">
            <el-switch :value="!scope.row.hide_from_homepage" @change="toggleHide(scope.row.activity_id, $event)"></el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column label="合同状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.contract_status === 1 ? 'success' : 'info'">
              {{ scope.row.contract_status === 1 ? '可签' : '不可签' }}
            </el-tag>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="activityDetail(scope.row.activity_id)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onPageChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          :layout="isMobile ? 'total, sizes, prev, pager, next' : 'total, sizes, prev, pager, next, jumper'"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import filterMixin from '@/utils/filter.js'

export default {
  name: 'Activities',
  mixins: [filterMixin],
  data() {
    return {
      isSearchExpanded: false,
      isMobile: false,
      sessionKey: 'ActivitiesSearch',
      filterFetchMethod: 'fetchActivities',
      activityList: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      searchQuery: {
        title_cn: '',
        title_ug: '',
        type: null,
        status: null,
        signup_status: null,
        is_deleted: 0,
        hide_from_homepage: null,
        contract_status: null
      },
      activityTypes: {
        1: '内地研学',
        2: '疆内研学',
        3: '主题研学',
        4: '订制团'
      },
      statusMap: {
        1: { text: '未开始', type: 'success' },
        2: { text: '进行中', type: 'success' },
        3: { text: '已结束', type: 'info' }
      }
    }
  },
  created() {
    this.fetchActivities()
    this.checkIsMobile()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    fetchActivities() {
      this.$http({
        method: 'get',
        url: 'activities/search',
        params: {
          ...this.searchQuery,
          page: this.pageNum,
          size: this.pageSize
        }
      }).then(res => {
        if (!res.success) return this.$message.error(res.message)
        this.activityList = res.data
        this.total = res.total
      }).catch(err => {
        this.$message.error(err.response?.data?.message || '获取活动列表失败')
      })
    },

    handleSearch() {
      this.pageNum = 1
      this.fetchActivities()
    },

    resetSearch() {
      this.searchQuery = { title_cn: '', title_ug: '', type: null, status: null, signup_status: null, is_deleted: 0, hide_from_homepage: null, contract_status: null }
      this.pageNum = 1
      this.pageSize = 10
      sessionStorage.removeItem(this.sessionKey)
      this.fetchActivities()
    },

    getActivityType(type) {
      return this.activityTypes[type] || '未知类型'
    },

    getStatusText(status) {
      return this.statusMap[status]?.text || '未知状态'
    },

    getStatusType(status) {
      return this.statusMap[status]?.type || ''
    },

    toggleHide(activityId, showOnHomepage) {
      this.$http.put(`activities/${activityId}`, { hide_from_homepage: !showOnHomepage }).then(res => {
        if (!res.success) return this.$message.error(res.message)
      }).catch(err => {
        this.$message.error(err.response?.data?.message || '更新失败')
      }).finally(() => {
        this.fetchActivities()
      })
    },

    activityDetail(id) {
      this.$router.push(`/admin/activity/details/${id}`)
    },

    onSizeChange(newSize) {
      this.pageSize = newSize
      this.fetchActivities()
    },

    onPageChange(newPage) {
      this.pageNum = newPage
      this.fetchActivities()
    },

    toggleSearch() {
      this.isSearchExpanded = !this.isSearchExpanded
    },

    checkIsMobile() {
      this.isMobile = window.innerWidth < 768
      if (this.isMobile) {
        this.isSearchExpanded = false
      }
    },

    handleResize() {
      const wasMobile = this.isMobile
      this.checkIsMobile()
      if (!wasMobile && this.isMobile) {
        this.isSearchExpanded = false
      } else if (wasMobile && !this.isMobile) {
        this.isSearchExpanded = true
      }
    }
  }
}
</script>

<style scoped>
.el-card {
  margin-top: 15px;
}
.el-table {
  margin-top: 15px;
}
.el-pagination {
  margin-top: 15px;
}
.deleted {
  color: #999;
}

.search-wrapper {
  margin-bottom: 10px;
}

.search-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: color 0.3s;
}

.search-toggle:hover {
  color: #409eff;
}

.search-toggle i {
  font-size: 14px;
}

.search-content {
  padding-top: 10px;
}

.search-row {
  margin-bottom: 10px;
}

.table-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 15px;
}

.table-scroll-wrapper .el-table {
  min-width: 100%;
}

.pagination-wrapper {
  margin-top: 15px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -webkit-overflow-scrolling: auto;
  touch-action: pan-x;
}

.pagination-wrapper .el-pagination {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  padding: 10px 0;
  min-width: max-content;
}

.pagination-wrapper .el-pagination::after {
  content: '';
  flex: 0 0 0;
}

@media (max-width: 768px) {
  .el-card {
    margin-top: 10px;
    padding: 10px;
  }

  .table-scroll-wrapper {
    margin-top: 10px;
  }

  .table-scroll-wrapper .el-table {
    font-size: 11px;
  }

  .table-scroll-wrapper .el-table th,
  .table-scroll-wrapper .el-table td {
    padding: 8px 5px !important;
  }

  .table-scroll-wrapper .el-button--small {
    font-size: 11px;
  }

  .table-scroll-wrapper .el-tag {
    font-size: 10px;
  }

  .table-scroll-wrapper .el-switch {
    transform: scale(0.8);
  }

  .pagination-wrapper {
    margin-top: 10px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x;
  }

  .pagination-wrapper .el-pagination {
    font-size: 10px;
    justify-content: flex-start;
    min-width: max-content;
  }

  .pagination-wrapper .btn-prev,
  .pagination-wrapper .btn-next {
    width: 26px;
    height: 26px;
    line-height: 26px;
    font-size: 11px;
    padding: 0;
  }

  .pagination-wrapper .el-pager li {
    padding: 0 2px;
    min-width: 22px;
    height: 26px;
    line-height: 26px;
    font-size: 10px;
  }

  .pagination-wrapper .el-pagination__total {
    font-size: 10px;
    margin-right: 8px;
  }

  .pagination-wrapper .el-pagination__sizes {
    margin-right: 8px;
  }

  .pagination-wrapper .el-pagination__sizes .el-input {
    width: 60px;
  }

  .pagination-wrapper .el-pagination__sizes .el-input__inner {
    height: 24px;
    font-size: 10px;
    padding: 0 5px;
  }

  .search-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .search-row .el-col {
    width: 100% !important;
    margin-bottom: 5px;
  }

  .search-content-mobile .el-input__inner,
  .search-content-mobile .el-select .el-input__inner {
    height: 34px;
    font-size: 13px;
  }

  .search-content-mobile .el-button {
    font-size: 12px;
    padding: 8px 12px;
  }

  .search-toggle {
    padding: 10px 0;
    font-size: 13px;
  }
}
</style> 